var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle } from 'react';
import * as S from './styles';
export var Checkbox = forwardRef(function (props, ref) {
    var checked = props.checked, onChange = props.onChange, activeColor = props.activeColor, inactiveColor = props.inactiveColor, iconColor = props.iconColor, idProp = props.id, rest = __rest(props, ["checked", "onChange", "activeColor", "inactiveColor", "iconColor", "id"]);
    useImperativeHandle(ref, function () { return ({ value: checked }); }, [checked]);
    var id = idProp || 'checkbox';
    return (_jsx(S.Checkbox, __assign({ ref: ref, id: id, type: "checkbox", "data-testid": "checkbox", checked: checked, activeColor: activeColor, inactiveColor: inactiveColor, iconColor: iconColor, onChange: onChange }, rest)));
});
